import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import WalletIcon from "@mui/icons-material/Wallet";
import DashboardIcon from "@mui/icons-material/Dashboard";

// Only permissions for pages that are backed by real backend endpoints.
// The astrology/consultant-era permissions (CONSULTANT, LANGUAGE, SERVICE,
// EXPERTISE, BANK_ACCOUNTS, TRANSFER_FUNDS, SUB_ADMIN, …) were removed along
// with their dead routes.
export const validPermissions = [
  "DASHBOARD",
  "USER",
  "PLANS",
  "CREDENTIALS",
];

export const rawMenu = [
  {
    key: "/dashboard",
    name: "Dashboard",
    element: <DashboardIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/dashboard",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/user",
    name: "User",
    element: <PersonIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/user",
    style: { background: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/plan",
    name: "Plans",
    element: <WalletIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/plan",
    fontSize: "1rem",
  },
  {
    key: "/credentials",
    name: "Credentials",
    element: <SecurityIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/credentials",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
];

// Every surviving page is backed and safe to expose, and Premika is operated
// by a single super-admin. Rather than filter the menu by backend permission
// strings (which were astrology-era and unreliable — they could hide working
// pages), show all working pages. Per-route access is still role-protected via
// ProtectedRoute in Routes.js.
export const getPermissionObjects = (/* userPermissions */) => {
  const permittedMenu = rawMenu;
  const permittedPaths = permittedMenu.map((m) => m.path);
  const defaultRoute = permittedPaths[0] || "/admin/user";

  return { permittedMenu, permittedPaths, defaultRoute };
};
